import { custom, success } from "./utilities";
import { ToastifyService, centerListingService } from "../../services";
import { centerListingConstant, globalSystemConstants } from "../../constants";

//-------Get all approved centers list for al users view
const getAllApprovedCentersList = (params) => {
  return (dispatch) => {
    if (params.length < 10 && params.pageNumber == 1) {
      dispatch(
        custom(
          centerListingConstant.GET_CENTER_PROFILE_DATA_BY_ID,
          globalSystemConstants.SPINNER_ACTIVATE
        )
      );
    }
    centerListingService
      .getAllApprovedCentersList(params)
      .then((response) => {
        dispatch(
          success(response, centerListingConstant.GET_ALL_APPROVED_CENTERS_LIST)
        );
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            centerListingConstant.GET_ALL_APPROVED_CENTERS_LIST,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};
//-------Get all approved centers list for al users view against spot
const getAllApprovedCentersListBySpotId = (params, spotId) => {
  return (dispatch) => {
    dispatch(
      custom(
        centerListingConstant.GET_ALL_APPROVED_CENTERS_LIST,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );

    centerListingService
      .getAllApprovedCentersListBySpotId(params, spotId)
      .then((response) => {
        dispatch(
          success(
            response,
            centerListingConstant.GET_ALL_APPROVED_CENTERS_LIST_BY_SPOTID
          )
        );
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            centerListingConstant.GET_ALL_APPROVED_CENTERS_LIST,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};
//Get center profile by id
const getCenterProfileById = (id) => {
  return (dispatch) => {
    dispatch(
      custom(
        centerListingConstant.GET_CENTER_PROFILE_DATA_BY_ID,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );

    centerListingService
      .getCenterProfileById(id)
      .then((response) => {
        dispatch(
          success(response, centerListingConstant.GET_CENTER_PROFILE_DATA_BY_ID)
        );
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            centerListingConstant.GET_CENTER_PROFILE_DATA_BY_ID,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//Get view center profile by id
const getViewCenterProfileById = (id) => {
  return (dispatch) => {
    dispatch(
      custom(
        centerListingConstant.GET_CENTER_PROFILE_DATA_BY_ID,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );

    centerListingService
      .getViewCenterProfileById(id)
      .then((response) => {
        dispatch(
          success(response, centerListingConstant.GET_CENTER_PROFILE_DATA_BY_ID)
        );
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            centerListingConstant.GET_CENTER_PROFILE_DATA_BY_ID,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------get all center instructors list
const getAllCenterInstructors = (params, centerId) => {
  return (dispatch) => {
    dispatch(
      custom(
        centerListingConstant.GET_ALL_CENTER_INSTRUCTORS_LIST,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );

    centerListingService
      .getAllCenterInstructors(params, centerId)
      .then((response) => {
        dispatch(
          success(
            response,
            centerListingConstant.GET_ALL_CENTER_INSTRUCTORS_LIST
          )
        );
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            centerListingConstant.GET_ALL_CENTER_INSTRUCTORS_LIST,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------get all center activities
const getAllCenterActivities = (params, centerId) => {
  return (dispatch) => {
    dispatch(
      custom(
        centerListingConstant.GET_ALL_CENTER_ACTIVITIES,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );

    centerListingService
      .getAllCenterActivities(params, centerId)
      .then((response) => {
        dispatch(
          success(response, centerListingConstant.GET_ALL_CENTER_ACTIVITIES)
        );
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            centerListingConstant.GET_ALL_CENTER_ACTIVITIES,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------export all center list actions
export const centerListingActions = {
  getCenterProfileById,
  getViewCenterProfileById,
  getAllApprovedCentersList,
  getAllCenterInstructors,
  getAllCenterActivities,
  getAllApprovedCentersListBySpotId,
};
